import { useState, useEffect, useRef } from 'react';
// import EmployeeCostSelector from '../EmployeeCostSelector';
// import HoursSetup from '../HoursSetup';
import { Button, Input, Modal, Row, Select, Space, Steps, Tabs, Typography } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { StartTutorialButton, SyncNow } from 'components/Global';
import ExportData from 'components/Global/ExportData';
import PayPeriod from 'components/settings/PayPeriods';
import { useDispatch, useSelector } from 'react-redux';
import { checkPermission, toastText } from 'utils/utils';
import DynamicTable from '../Table';
import './index.scss';
import { deleteApi, getApi, postApi } from 'redux/apis';
import { AppDispatch } from 'redux/store';
import { getEmployeeCostAction } from 'redux/action/employeeCostAction';
import { employeeCostSyncDate } from 'redux/slice/companySlice';
import styles from './index.module.scss';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { fetchClosingDateAction } from 'redux/action/closingDateAction';
import { updateNotIncludedEmployeeIds } from 'redux/slice/employeeCostSlice';
import { DownOutlined } from '@ant-design/icons'; // Import DownOutlined for dropdown icon
import { Dropdown } from 'antd';
import { CloseSvg } from 'utils/svgs';
import UploadFileForm from '../UploadEmployeeCost/UploadFileForm';
import HeaderMappingForm from '../UploadEmployeeCost/HeaderMappingForm';
import DataMappingForm from '../UploadEmployeeCost/DataMappingForm';
import DataReviewTable from '../UploadEmployeeCost/DataReviewTable';
import Papa from 'papaparse';
import * as XLSX from 'xlsx';
import SmartImportWizard from '../SmartImport/SmartImportWizard';
import NewFieldsModal from '../NewFieldsModal';
import { CHAT_IMPORT_EVENT, consumeChatImport } from 'utils/pendingChatImport';
import QboTimeMismatchBanner from '../QboTimeMismatchBanner';
import QboTimeMismatchPanel from '../QboTimeMismatchPanel';
import moment from 'moment-timezone';
import { getEmployeeCostColumnAction } from 'redux/action/employeeCostColumnSlice';
import { getConfiguration } from 'redux/action/configurationAction';

// import { ImportEmployeeCostCsvModal } from '../ImportEmployeeCostValueModal';
// import { useSelector } from 'react-redux';

const EmployeeCosts = ({
	// onChangeKey,
	onChangePayPeriod,
	onChangeCostValue,
	showPreviewCostAllocation,
	isValueChanged,
}: any) => {
	const [queryParams, setQueryParams] = useSearchParams();
	// Lets a deep link land directly on the Pay Period tab (key "2") instead of
	// always defaulting to Employee Cost — e.g. the AI assistant navigating
	// here for "open pay period" needs this, not just the payPeriodId filter.
	const [isEmployeeCost, setIsEmployeeCost] = useState(
		queryParams.get('tab') === 'payPeriod' ? '2' : '1'
	);
	// Re-applies the same tab param on every navigation here, not just the
	// first mount — the lazy useState initializer above alone doesn't re-run
	// when the AI assistant (or any link) sends the user back to this exact
	// page while it's already mounted, since React Router doesn't remount a
	// routed page for a same-pathname navigation. Without this, re-navigating
	// to "Employee Costs" while already on the Pay Period tab silently did
	// nothing — the URL changed but nothing ever read it again.
	useEffect(() => {
		setIsEmployeeCost(queryParams.get('tab') === 'payPeriod' ? '2' : '1');
	}, [queryParams.get('tab')]);
	const [lastSyncTime, setLastSyncTime] = useState(new Date());
	const [syncLoading, setSyncLoading] = useState(false);

	const [payPeriodId, setPayPeriodId] = useState<string | null>(
		queryParams.get('payPeriodId') || localStorage.getItem('payPeriod')
	);

	// ENG-374: reminder shown after a Smart Import that created new fields, prompting
	// the user to map their GL accounts on the Configurations page.
	const [showNewFieldsModal, setShowNewFieldsModal] = useState(false);
	const [newFieldLabels, setNewFieldLabels] = useState<string[]>([]);

	// ENG-374: open Settings → Configurations directly. Two steps, nothing else — no
	// handleConfigOpen (every one of those gates on QBO connection), no route change,
	// no Redux dispatch. The global layout (layouts/Global) opens the Settings drawer
	// when it sees openDrawer=true and renders the panel named by localStorage
	// 'settings'. The openDrawer query param is added IN PLACE (existing params kept).
	const goToConfigurations = () => {
		setShowNewFieldsModal(false);
		localStorage.setItem('settings', 'Configurations');
		const nextParams = new URLSearchParams(queryParams);
		nextParams.set('openDrawer', 'true');
		setQueryParams(nextParams);
	};
	const [searchValue, setSearchValue] = useState<string | null>(null);
	const [includeInactive, setIncludeInactive] = useState(false);
	const [
		showEmployeeWithAllocationConfig,
		setShowEmployeeWithAllocationConfig,
	] = useState(false);

	const [openEmployeeCostModal, setOpenEmployeeCostModal] = useState(false);
	const [showPayPeriodCreationRefresh, setShowPayPeriodCreationRefresh] =
		useState(false);

	// console.log('showPayPeriodCreationRefresh: ', showPayPeriodCreationRefresh);
	const [showEmployeeCostRefresh, setShowEmployeeCostRefresh] = useState(false);
	// console.log('showEmployeeCostRefresh: ', showEmployeeCostRefresh);
	let items = [];

	const payPeriods = useSelector((state: any) => state?.payPeriods?.optionData);

	const dispatch = useDispatch<AppDispatch>();
	const navigate = useNavigate();

	const selectedCompanyPermission = useSelector(
		(state: any) => state?.companies?.selectedCompanyDetails?.role?.permissions
	);

	const { data: employeeCosts, notIncludedEmployeeIds } = useSelector(
		(state: any) => state?.employeeCosts
	);

	const employeeLastSyncDate = useSelector(
		(state: any) =>
			state?.companies?.selectedCompanyDetails?.company?.employeeLastSyncDate
	);

	const isViewPayPeriodPermission = checkPermission(selectedCompanyPermission, {
		permissionName: 'Pay Period',
		permission: ['view'],
	});

	const isAddEmployeeCostPermission = checkPermission(
		selectedCompanyPermission,
		{
			permissionName: 'Employee Cost',
			permission: ['add'],
		}
	);

	const isEditEmployeeCostPermission = checkPermission(
		selectedCompanyPermission,
		{
			permissionName: 'Employee Cost',
			permission: ['edit'],
		}
	);

	const isTableLoading = useRef(false);

	const setIsTableLoading = (value: boolean) => {
		isTableLoading.current = value;
	};

	const changeEmployeeCost = (isEmployeeCost: string) => {
		setIsEmployeeCost(isEmployeeCost);
	};

	const handleSync = () => {
		setSyncLoading(true);
		postApi(`/employees/sync`, {
			companyId: localStorage.getItem('companyId'),
		})
			.then((data) => {
				dispatch(
					getEmployeeCostAction({
						page: 1,
						limit: -1,
						sort: 'asc',
						payPeriodId: payPeriodId,
						includeInactive,
					})
				);
				dispatch(employeeCostSyncDate());
				dispatch(fetchClosingDateAction({ syncLogs: true }));
				toastText(data.data?.message, 'success');
				// WS-13 (ENG-332) / ENG-382: surface QBO names that couldn't be
				// matched. Re-fetch the full-roster read endpoint rather than trusting
				// the sync response, whose `unmatchedNames` reflect only the QBO delta
				// since the last sync and would overwrite a valid banner with [].
				void refetchUnmatchedNames();
				setSyncLoading(false);
				// setPayPeriodId(null);
				localStorage.removeItem('payPeriod');
			})
			.catch((err) => {
				toastText(err?.response?.data?.message, 'error');
				setSyncLoading(false);
			});
	};

	const handleInactive = (value: boolean) => {
		setIncludeInactive(value);
	};

	const handleShowEmployeeWithAllocationConfig = (value: boolean) => {
		setShowEmployeeWithAllocationConfig(value);
	};

	const handleEmployeeModalClose = () => {
		setOpenEmployeeCostModal(false);
	};

	useEffect(() => {
		onChangePayPeriod && onChangePayPeriod(payPeriodId);
	}, [payPeriodId]);

	const [smartImportOpen, setSmartImportOpen] = useState(false);
	const [chatImportFile, setChatImportFile] = useState<File | null>(null);

	// Wakes up when the AI chatbot hands off a file for "Import Employee
	// Cost" (see utils/pendingChatImport) — opens Smart Import pre-loaded with
	// it. The on-mount check covers navigating here fresh from another page;
	// the event listener covers already being on this page when it's sent.
	useEffect(() => {
		const openFromChat = (file: File) => {
			setChatImportFile(file);
			setSmartImportOpen(true);
		};
		const existing = consumeChatImport('smart');
		if (existing) openFromChat(existing);
		const handler = () => {
			const file = consumeChatImport('smart');
			if (file) openFromChat(file);
		};
		window.addEventListener(CHAT_IMPORT_EVENT, handler);
		return () => window.removeEventListener(CHAT_IMPORT_EVENT, handler);
	}, []);

	// WS-13 (ENG-332): QBO Time mismatch banner state. `unmatchedNames` is the
	// current set of QBO DisplayNames with no CAP match; the banner collapses to a
	// badge when dismissed, and the panel resolves the names into qbo_time_name
	// aliases. All state is local (no Redux slice).
	const companyId = localStorage.getItem('companyId') ?? '';
	const [unmatchedNames, setUnmatchedNames] = useState<string[]>([]);
	const [bannerDismissed, setBannerDismissed] = useState(false);
	const [mismatchPanelOpen, setMismatchPanelOpen] = useState(false);

	// ENG-382: re-derive the banner from the full QBO roster (the read endpoint),
	// independent of the last-sync delta. The sync response only reports mismatches
	// among employees that changed since the last sync, so trusting it would hide
	// pre-existing mismatches. Non-blocking: a failed fetch logs and leaves the
	// prior banner state untouched.
	const refetchUnmatchedNames = async () => {
		if (!companyId) return;
		try {
			const res = await getApi('/employees/unmatched-names', {
				companyId,
			});
			const names: string[] = res.data?.data?.unmatchedNames ?? [];
			setUnmatchedNames(names);
			if (names.length > 0) setBannerDismissed(false);
		} catch (err) {
			console.error(
				'[ENG-382] Failed to fetch unmatched QBO employee names:',
				err
			);
		}
	};

	// On mount, derive the banner from the current unmatched set so it persists
	// across page refreshes (independent of the last sync). A fresh page load
	// shows the full banner, not the collapsed badge.
	useEffect(() => {
		if (!companyId) return;
		let cancelled = false;
		getApi('/employees/unmatched-names', { companyId })
			.then((res) => {
				if (cancelled) return;
				const names: string[] = res.data?.data?.unmatchedNames ?? [];
				setUnmatchedNames(names);
				if (names.length > 0) setBannerDismissed(false);
			})
			.catch((err) => {
				// ENG-382: non-blocking, but no longer silent — a failed fetch left
				// the banner hidden with no signal. Log so QBO/backend failures are
				// diagnosable; do not toast (a banner fetch must not interrupt the page).
				console.error(
					'[ENG-382] Failed to fetch unmatched QBO employee names:',
					err
				);
			});
		return () => {
			cancelled = true;
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [companyId]);

	// Pay period label for the Step 4 reminder line — same date-range format the
	// PayPeriodFilter renders ("MM/DD/YYYY - MM/DD/YYYY").
	const selectedPayPeriod = payPeriods?.find(
		(p: any) => p.id === payPeriodId
	);
	const payPeriodLabel =
		selectedPayPeriod?.startDate && selectedPayPeriod?.endDate
			? `${moment(selectedPayPeriod.startDate)
					.tz(process.env.REACT_APP_TIMEZONE!)
					.format('MM/DD/YYYY')} - ${moment(selectedPayPeriod.endDate)
					.tz(process.env.REACT_APP_TIMEZONE!)
					.format('MM/DD/YYYY')}`
			: '';

	const handleMenuClick = (e: any) => {
		if (e.key === 'import') {
			setOpenEmployeeCostModal(true);
		} else if (e.key === 'upload') {
			openTimeLogUploadModalHandler();
		} else if (e.key === 'smart') {
			setSmartImportOpen(true);
		}
		// Add logic for Upload Employee Cost if needed
	};

	/* 	const menu = (
		<Menu onClick={handleMenuClick}>
			{employeeCosts.length > 0 ? (
				<>
					<Menu.Item key="import">Import From Template</Menu.Item>
					<Menu.Item key="upload">Custom Import</Menu.Item>
				</>
			) : (
				<Menu.Item key="upload">Custom Import</Menu.Item>
			)}
		</Menu>
	); */

	const menu = {
		onClick: handleMenuClick,
		items: [
			{
				key: 'upload',
				label: 'Custom Import',
				style: { fontSize: '12px' },
			},
			{
				key: 'smart',
				label: 'Smart Import',
				style: { fontSize: '12px' },
			},
		],
	};

	const [isTimeLogUploadModalOpen, setIsTimeLogUploadModalOpen] =
		useState(false);

	const openTimeLogUploadModalHandler = async () => {
		setIsTimeLogUploadModalOpen(true);
		refreshEcTemplates();
	};

	const [file, setFile] = useState<any>(null);

	if (isViewPayPeriodPermission) {
		items = [
			{
				key: '1',
				label: 'Employee Cost',
				children: (
					<>
						<div className={styles['employee-costs__tabs-header']}>
							<StartTutorialButton tutorial="payrollAllocation" />
							{(isAddEmployeeCostPermission ||
								isEditEmployeeCostPermission) && (
									<div
										className={styles['employee-costs__tabs-header--sync-now']}
										data-tour-target="tutorial-sync-employees"
									>
										<Space className={styles['search-filter']}>
											<SyncNow
												syncDate={lastSyncTime}
												tooltip="Sync the employees from QuickBooks."
												handleSync={handleSync}
												isLoading={syncLoading}
											/>
										</Space>
									</div>
								)}
							{notIncludedEmployeeIds?.length > 0 && payPeriodId && (
								<div
									className={
										styles['employee-costs__tabs-header--show-all-employees']
									}
								>
									<Space className={styles['search-filter']}>
										<button
											onClick={() => {
												dispatch(
													updateNotIncludedEmployeeIds({
														notIncludedEmployeeIds: [],
													})
												);
											}}
											className="btn-black"
											style={{ height: '41px' }}
										>
											Show All Employees
										</button>
									</Space>
								</div>
							)}
							{isEmployeeCost == '1' &&
								showPreviewCostAllocation &&
								isValueChanged ? (
								<div
									className={
										styles[
										'employee-costs__tabs-header--preview-costallocation'
										]
									}
								>
									<button
										className="btn-black"
										onClick={() => {
											navigate(`/cost-allocations?payPeriod=${payPeriodId}`);
										}}
										style={{ height: '41px' }}
									>
										Preview Cost Allocation
									</button>
								</div>
							) : null}
							{payPeriodId && isAddEmployeeCostPermission && (
								<div
									className={
										styles['employee-costs__tabs-header--import-employee-cost']
									}
									data-tour-target="tutorial-import-employee-cost"
								>
									{/* {employeeCosts.length > 0 && payPeriodId && ( */}

									<Dropdown
										menu={menu}
										trigger={['click']}
									>
										<button
											className="btn-black"
											style={{ height: '41px' }}
										>
											Import Employee Cost <DownOutlined />
										</button>
									</Dropdown>
								</div>
							)}
							{employeeCosts?.length > 0 && payPeriodId && (
								<div className="employee-costs__tabs-header--export">
									<Space className={styles['search-filter']}>
										<ExportData
											params={{
												search: searchValue,
												payPeriodId: payPeriodId,
												payPeriodData: payPeriods.find(
													(payPeriod: any) => payPeriod.id === payPeriodId
												),
												includeInactive: includeInactive,
											}}
											moduleName="employeeCost"
										/>
									</Space>
								</div>
							)}
						</div>

						<div>
							{notIncludedEmployeeIds?.length ? (
								<p
									style={{
										padding: '10px 20px 0px 20px',
										color: '#333',
										fontSize: '12px',
										fontStyle: 'italic',
									}}
								>
									Note: The following employees are missing time entries or need
									to be configured with a fixed percentage.
								</p>
							) : null}

							<DynamicTable
								onChangePayPeriod={(value: string | null) => {
									setPayPeriodId(value);
								}}
								onChangeSearchValue={(value: string | null) => {
									setSearchValue(value);
								}}
								handleInactive={handleInactive}
								includeInactive={includeInactive}
								onChangeCostValue={(flag: boolean) => {
									onChangeCostValue && onChangeCostValue(flag);
								}}
								onChangeShowEmployeeWithAllocationConfig={
									handleShowEmployeeWithAllocationConfig
								}
								showEmployeeWithAllocationConfig={
									showEmployeeWithAllocationConfig
								}
								onCloseEmployeeCostModal={handleEmployeeModalClose}
								openEmployeeCostModal={openEmployeeCostModal}
								handleShowPayPeriodCreationRefresh={(data: any) =>
									setShowPayPeriodCreationRefresh(data)
								}
								showPayPeriodCreationRefresh={showPayPeriodCreationRefresh}
								handleShowEmployeeCostRefresh={(data: any) =>
									setShowEmployeeCostRefresh(data)
								}
								showEmployeeCostRefresh={showEmployeeCostRefresh}
								isTableLoading={isTableLoading}
								setIsTableLoading={setIsTableLoading}
							/>
						</div>

						{/* {
							openEmployeeCostModal ? (
								<ImportEmployeeCostCsvModal
									open={openEmployeeCostModal}
									onClose={() => handleEmployeeModalClose()}
								/>
							) : null
						} */}
					</>
				),
			},
			{
				key: '2',
				label: 'Pay Period',
				children: <PayPeriod changeEmployeeCost={changeEmployeeCost} />,
			},
		];
	} else {
		items = [
			{
				key: '1',
				label: 'Employee Cost',
				children: (
					<>
						<div className={styles['employee-costs__tabs-header']}>
							<StartTutorialButton tutorial="payrollAllocation" />
							{(isAddEmployeeCostPermission ||
								isEditEmployeeCostPermission) && (
									<div
										className={styles['employee-costs__tabs-header--sync']}
										data-tour-target="tutorial-sync-employees"
									>
										<Space className={styles['search-filter']}>
											<SyncNow
												syncDate={lastSyncTime}
												tooltip="Sync the employees from QuickBooks."
												handleSync={handleSync}
												isLoading={syncLoading}
											/>
										</Space>
									</div>
								)}
							{notIncludedEmployeeIds?.length > 0 && payPeriodId && (
								<div
									className={
										styles['employee-costs__tabs-header--show-all-employees']
									}
								>
									<Space className={styles['search-filter']}>
										<button
											onClick={() => {
												dispatch(
													updateNotIncludedEmployeeIds({
														notIncludedEmployeeIds: [],
													})
												);
											}}
											className="btn-black"
											style={{ height: '41px' }}
										>
											Show All Employees
										</button>
									</Space>
								</div>
							)}
							{isEmployeeCost == '1' &&
								showPreviewCostAllocation &&
								isValueChanged ? (
								<div
									className={
										styles[
										'employee-costs__tabs-header--preview-costallocation'
										]
									}
								>
									<button
										className="btn-black"
										onClick={() => {
											navigate(`/cost-allocations?payPeriod=${payPeriodId}`);
										}}
										style={{ height: '41px' }}
									>
										Preview Cost Allocation
									</button>
								</div>
							) : null}
							{payPeriodId && isAddEmployeeCostPermission && (
								<div
									className={
										styles['employee-costs__tabs-header--import-employee-cost']
									}
									data-tour-target="tutorial-import-employee-cost"
								>
									{/* {employeeCosts.length > 0 && payPeriodId && ( */}

									<Dropdown
										menu={menu}
										trigger={['click']}
									>
										<button
											className="btn-black"
											style={{ height: '41px' }}
										>
											Import Employee Cost <DownOutlined />
										</button>
									</Dropdown>
								</div>
							)}
							{employeeCosts?.length > 0 && payPeriodId && (
								<div className="employee-costs__tabs-header--export">
									<Space className={styles['search-filter']}>
										<ExportData
											params={{
												search: searchValue,
												payPeriodId: payPeriodId,
												payPeriodData: payPeriods.find(
													(payPeriod: any) => payPeriod.id === payPeriodId
												),
												includeInactive: includeInactive,
											}}
											moduleName="employeeCost"
										/>
									</Space>
								</div>
							)}
						</div>

						<div>
							{notIncludedEmployeeIds?.length ? (
								<p
									style={{
										padding: '10px 20px 0px 20px',
										color: '#333',
										fontSize: '12px',
										fontStyle: 'italic',
									}}
								>
									Note: The following employees are missing time entries or need
									to be configured with a fixed percentage.
								</p>
							) : null}

							<DynamicTable
								onChangePayPeriod={(value: string | null) => {
									setPayPeriodId(value);
								}}
								onChangeSearchValue={(value: string | null) => {
									setSearchValue(value);
								}}
								handleInactive={handleInactive}
								includeInactive={includeInactive}
								onChangeCostValue={(flag: boolean) => {
									onChangeCostValue && onChangeCostValue(flag);
								}}
								showEmployeeWithAllocationConfig={
									showEmployeeWithAllocationConfig
								}
								onChangeShowEmployeeWithAllocationConfig={
									handleShowEmployeeWithAllocationConfig
								}
								onCloseEmployeeCostModal={handleEmployeeModalClose}
								openEmployeeCostModal={openEmployeeCostModal}
								handleShowPayPeriodCreationRefresh={(data: any) =>
									setShowPayPeriodCreationRefresh(data)
								}
								showPayPeriodCreationRefresh={showPayPeriodCreationRefresh}
								handleShowEmployeeCostRefresh={(data: any) =>
									setShowEmployeeCostRefresh(data)
								}
								showEmployeeCostRefresh={showEmployeeCostRefresh}
								isTableLoading={isTableLoading}
								setIsTableLoading={setIsTableLoading}
							/>
						</div>

						{/* {
							openEmployeeCostModal ? (
								<ImportEmployeeCostCsvModal
									open={openEmployeeCostModal}
									onClose={() => handleEmployeeModalClose()}
								/>
							) : null
						} */}
					</>
				),
			},
		];
	}

	const [headers, setHeaders] = useState<any[]>([]);
	const [current, setCurrent] = useState(0);
	const [data, setData] = useState<any[]>([]);
	const [isTimeActivityChecked, setIsTimeActivityChecked] =
		useState<boolean>(false);
	const [fileEmployeeValues, setFileEmployeeValues] = useState<any[]>([]);
	const [selectHeadersValues, setHeadersSelectValues] = useState({
		activityDate: [],
		OtherExpensesAccounts: [],
		salaryExpenseAccounts: [],
		payrollTaxesAndFringeBenefits: [],
		employee: [],
		customer: [],
		class: [],
		hours: [],
	});

	const [fileClassValues, setFileClassValues] = useState<any[]>([]);
	const [fileCustomerValues, setFileCustomerValues] = useState<any[]>([]);

	const { optionData: classList } = useSelector((state: any) => state.class);
	const { data: employees } = useSelector((state: any) => state.employees);
	const { optionData: customerOptions } = useSelector(
		(state: any) => state.customer
	);
	const [historyOfMapping, setHistoryOfMapping] = useState({
		classMapping: [],
		employeeMapping: [],
		customerMapping: [],
	});
	const [checkedTitles, setCheckedTitles] = useState({});

	// Custom Import mapping templates (Employee Cost Mapping Template) — a
	// named/multi/selectable alternative to the silent single "last mapping"
	// above (historyOfMapping / TimelogMappingHistory), which stays untouched
	// so Time Activity import keeps working exactly as before.
	const EC_MAPPING_TEMPLATES_URL = '/employee-cost/mapping-templates';
	// Sentinel dropdown entry for the case where the wizard opened with the
	// silent "last used" mapping (TimelogMappingHistory, via getMappingHistory
	// below) already applied, but the user hasn't explicitly picked one of
	// their named templates — without this the dropdown looked empty even
	// though a mapping WAS in effect, which read as "nothing is applied".
	const EC_LAST_USED_VALUE = '__ec_last_used__';
	const [ecMappingTemplates, setEcMappingTemplates] = useState<any[]>([]);
	const [loadedEcTemplateId, setLoadedEcTemplateId] = useState<string | null>(
		null
	);
	const [ecUsingLastMapping, setEcUsingLastMapping] = useState(false);
	const [ecSaveAsOpen, setEcSaveAsOpen] = useState(false);
	const [ecSaveAsName, setEcSaveAsName] = useState('');

	const refreshEcTemplates = async () => {
		try {
			const res = await getApi(EC_MAPPING_TEMPLATES_URL, {
				companyId: localStorage.getItem('companyId'),
			});
			setEcMappingTemplates(Array.isArray(res.data?.data) ? res.data.data : []);
		} catch (error) {
			console.error('Error fetching Employee Cost mapping templates:', error);
		}
	};

	const currentEcTemplateName =
		ecMappingTemplates.find((t) => t.id === loadedEcTemplateId)?.name ?? '';

	// Shared by getDataMapping() (the step 1 -> 2 transition) and
	// handleApplyEcTemplate (loading a template while already on step 2, where
	// that transition has already happened and won't fire again). Extracts the
	// current file's distinct values for `fields` and overlays `mapping` onto
	// matching keys — same semantics as the original inline processValues.
	const buildFileValues = (fields: any[], mapping: any[], nameKey: string) => {
		const values = data
			.map((item) =>
				(fields ?? [])
					.map((field) => item[field])
					.filter(
						(value) =>
							value !== null &&
							value?.toString().trim() !== '' &&
							value?.toString().trim() !== '_'
					)
					.join('_')
			)
			.filter((value) => value !== '');

		const uniqueValues = Array.from(new Set(values));

		const initialValues = uniqueValues
			.filter((value) => value !== '' && value != null)
			.map((value) => ({
				key: value.trim(),
				selectedValue: '',
				[nameKey]: '',
			}));

		return initialValues.map((item) => {
			const map = (mapping ?? []).find((m) => m.key.trim() === item.key.trim());
			if (map) {
				return {
					...item,
					selectedValue:
						item.selectedValue === '' ? map.selectedValue : item.selectedValue,
					[nameKey]: item[nameKey] === '' ? map[nameKey] : item[nameKey],
				};
			}
			return item;
		});
	};

	// Applying a template re-uses the exact same setters getMappingHistory()
	// already uses to auto-apply the silent last mapping, so getDataMapping()'s
	// existing processValues overlay pre-fills the Data Mapping step for free
	// when the template is loaded from step 1 (Header Mapping) and the user
	// then advances to step 2. When loaded while ALREADY on step 2 (Data
	// Mapping), that 1->2 transition has already happened and won't fire
	// again, so fileClassValues/fileEmployeeValues/fileCustomerValues must be
	// recomputed here directly — otherwise the Data Mapping rows stay stale
	// (still reflecting whatever was there before the template was applied).
	const handleApplyEcTemplate = (templateId: string) => {
		const template = ecMappingTemplates.find((t) => t.id === templateId);
		if (!template) return;
		const m = template.mappings ?? {};

		const validatedHeaderMapping: any = {};
		for (const key in m.headerMapping ?? {}) {
			const mappingValues = m.headerMapping[key] ?? [];
			validatedHeaderMapping[key] = mappingValues.filter((value: any) =>
				headers.includes(value)
			);
		}

		setHeadersSelectValues(validatedHeaderMapping);
		setCheckedTitles(m.checkedHeaders ?? {});
		setHistoryOfMapping({
			classMapping: m.classMapping ?? [],
			employeeMapping: m.employeeMapping ?? [],
			customerMapping: m.customerMapping ?? [],
		});
		setLoadedEcTemplateId(templateId);
		setEcUsingLastMapping(false);

		if (current === 2) {
			setFileClassValues(
				buildFileValues(validatedHeaderMapping.class, m.classMapping, 'qboClassName')
			);
			setFileEmployeeValues(
				buildFileValues(
					validatedHeaderMapping.employee,
					m.employeeMapping,
					'qboEmployeeName'
				)
			);
			setFileCustomerValues(
				buildFileValues(
					validatedHeaderMapping.customer,
					m.customerMapping,
					'qboCustomerName'
				)
			);
		}
	};

	const buildEcTemplatePayload = () => ({
		headerMapping: selectHeadersValues,
		classMapping: fileClassValues,
		employeeMapping: fileEmployeeValues,
		customerMapping: fileCustomerValues,
		checkedHeaders: checkedTitles,
	});

	const handleSaveEcTemplate = async () => {
		if (!loadedEcTemplateId) {
			setEcSaveAsName('');
			setEcSaveAsOpen(true);
			return;
		}
		try {
			await postApi(EC_MAPPING_TEMPLATES_URL, {
				id: loadedEcTemplateId,
				companyId: localStorage.getItem('companyId'),
				name: currentEcTemplateName,
				mappings: buildEcTemplatePayload(),
			});
			toastText('Template updated.', 'success');
			await refreshEcTemplates();
		} catch (error) {
			toastText('Could not save the template. Please try again.', 'error');
		}
	};

	const handleSaveAsEcTemplate = async () => {
		const name = ecSaveAsName.trim();
		if (!name) return;
		try {
			const res = await postApi(EC_MAPPING_TEMPLATES_URL, {
				companyId: localStorage.getItem('companyId'),
				name,
				mappings: buildEcTemplatePayload(),
			});
			if (res.data?.data?.id) {
				setLoadedEcTemplateId(res.data.data.id);
			}
			toastText('Template saved.', 'success');
			setEcSaveAsOpen(false);
			setEcSaveAsName('');
			await refreshEcTemplates();
		} catch (error) {
			toastText('Could not save the template. Please try again.', 'error');
		}
	};

	const handleDeleteEcTemplate = async (template: any) => {
		try {
			await deleteApi(`${EC_MAPPING_TEMPLATES_URL}/${template.id}`);
			if (loadedEcTemplateId === template.id) {
				setLoadedEcTemplateId(null);
			}
			await refreshEcTemplates();
			toastText('Template deleted.', 'success');
		} catch (error) {
			toastText('Could not delete the template. Please try again.', 'error');
		}
	};

	const confirmDeleteEcTemplate = (template: any) => {
		Modal.confirm({
			title: 'Delete template?',
			content: `"${template.name}" will be permanently deleted.`,
			okText: 'Delete',
			okButtonProps: { danger: true },
			onOk: () => handleDeleteEcTemplate(template),
		});
	};

	const getMappingHistory = () => {
		const fetchTimelogMappingHistory = async () => {
			try {
				// Make the API call to get timelog mapping history
				const response = await postApi(
					'/time-activities/timelog-mapping-history',
					{
						companyId: localStorage.getItem('companyId'),
					}
				);

				const mappingData = response.data?.data?.mappingData; // Fallback to empty object if mappingData is undefined

				const {
					headerMapping,
					classMapping,
					employeeMapping,
					customerMapping,
					checkedHeaders,
				} = mappingData?.employeeCost ? mappingData.employeeCost : mappingData;

				if (headerMapping) {
					// Create a new object to store the validated header mappings
					const validatedHeaderMapping: any = {};

					// Loop through each key in the `headerMapping`
					for (const key in headerMapping) {
						// Get the value from headerMapping
						const mappingValues = headerMapping[key];

						// Filter the mapping values based on their presence in `headers`
						const filteredValues = mappingValues.filter((value: any) =>
							headers.includes(value)
						);

						// If no values are matched, add the key with an empty array
						// Otherwise, add the key with the matched values
						validatedHeaderMapping[key] =
							filteredValues.length > 0 ? filteredValues : [];
					}

					// Update the state with the validated header mapping
					setHeadersSelectValues(validatedHeaderMapping);
					setCheckedTitles(checkedHeaders);
					// Only flag as "last used" if the user hasn't already picked an
					// explicit named template — this effect can re-run (it's keyed on
					// [headers, payPeriodId]) after that pick without clobbering it.
					setLoadedEcTemplateId((current) => {
						if (!current) setEcUsingLastMapping(true);
						return current;
					});
				}

				// Update historyOfMapping state
				setHistoryOfMapping({
					classMapping: classMapping || [], // Fallback to empty array if classMapping is undefined
					employeeMapping: employeeMapping || [], // Fallback to empty array if employeeMapping is undefined
					customerMapping: customerMapping || [], // Fallback to empty array if customerMapping is undefined
				});
			} catch (error) {
				console.error('Error fetching timelog mapping history:', error);
				// Handle error (optional: display a message to the user)
			}
		};

		fetchTimelogMappingHistory();
	}; // Empty dependency array means this effect runs once on mount

	useEffect(() => {
		getMappingHistory();
	}, [headers, payPeriodId]); // Dependency array includes headers

	useEffect(() => {
		getMappingHistory();
	}, []);

	const [selectHeadersValidation, setHeadersSelectValidation] = useState({
		activityDate: false,
		employee: false,
		OtherExpensesAccounts: false,
		salaryExpenseAccounts: false,
		payrollTaxesAndFringeBenefits: false,
		customer: false,
		class: false,
		hours: false,
	});

	const validateHeaders = () => {
		let isValid = true;
		const newValidationState: any = { ...selectHeadersValidation };

		Object.keys(selectHeadersValues).forEach((key: any) => {
			if (
				selectHeadersValues[key as keyof typeof selectHeadersValues].length ===
				0
			) {
				newValidationState[key] = true;
				isValid = false;
			} else {
				newValidationState[key] = false;
			}
		});

		setHeadersSelectValidation(newValidationState);
		return isValid;
	};

	const handleSelectChange = (key: string, value: any) => {
		setHeadersSelectValues((prevValues) => ({
			...prevValues,
			[key]: value,
		}));
		setHeadersSelectValidation((prevValues) => ({
			...prevValues,
			[key]: value.length ? false : true,
		}));
	};

	const handleHeadersSubmitButton = () => {
		const validationPassed = validateHeaders();
		if (validationPassed) {
			console.log('All fields are valid.');
			// Add your logic here when validation passes
		} else {
			console.log('Validation failed.');
			// Add your logic here when validation fails
		}
	};

	const handleTreeSelectChange = (key: string, value: string, data: any) => {
		setFileClassValues((prevValues) =>
			prevValues.map((item) =>
				item.key === key
					? { ...item, selectedValue: value, qboClassName: data[0] }
					: item
			)
		);
	};

	const handleCustomerTreeSelectChange = (
		key: string,
		value: string,
		data: any
	) => {
		setFileCustomerValues((prevValues) =>
			prevValues.map((item) =>
				item.key === key
					? { ...item, selectedValue: value, qboCustomerName: data[0] }
					: item
			)
		);
	};

	const handleEmployeeSelectChange = (
		key: string,
		value: string,
		data: any
	) => {
		setFileEmployeeValues((prevValues) =>
			prevValues.map((item) =>
				item.key === key
					? {
						...item,
						selectedValue: value,
						qboEmployeeName: data?.children,
					}
					: item
			)
		);
	};

	const handleBack = () => {
		setHeadersSelectValues(selectHeadersValues);
		setFileEmployeeValues(fileEmployeeValues);

		setCurrent(current - 1);
	};

	const handleContinue = (values: any) => {
		if (!values.file) {
			toastText('Please upload a file first', 'error');
			return;
		}

		const file = values.file;
		const fileSizeInMB = file.size / (1024 * 1024);
		if (fileSizeInMB <= 2) {
			// Updated size check to 2MB
			setFile(file);
			const fileType = file.name.split('.').pop();
			if (fileType) {
				switch (fileType.toLowerCase()) {
					case 'csv':
						processCSV(file);
						break;
					case 'xls':
					case 'xlsx':
						processExcel(file);
						break;
					default:
						toastText('Unsupported file type', 'error');
						setFile(null);
				}
				console.log('values', values, headers, data, selectHeadersValues);
			}
		} else {
			console.log('size limit crossed');
			toastText('File size must be smaller than 2MB', 'error');
			setFile(null);
		}
	};

	const handleImportedEmployeeCost = () => {
		// initialCall();
		// formateTimeLogData();
	};

	const processCSV = (file: any) => {
		const reader = new FileReader();

		reader.onload = (event: any) => {
			const text = event.target.result;

			// Use PapaParse to properly handle CSV parsing, including commas in values
			Papa.parse(text, {
				header: true, // Automatically uses the first row as headers
				skipEmptyLines: true, // Skips empty lines
				complete: (result: any) => {
					if (result && result.data && result.data.length > 0) {
						const headers = Object.keys(result.data[0]);
						const data = result.data;

						setHeaders(headers);
						setData(data);
					} else {
						toastText('CSV file is empty or invalid!', 'error');
					}
				},
				error: () => {
					toastText('Failed to parse the CSV file!', 'error');
				},
			});
		};

		reader.onerror = () => {
			toastText('Failed to read the file!', 'error');
		};

		reader.readAsText(file);
	};

	const processExcel = (file: File) => {
		const reader = new FileReader();

		reader.onload = (event: ProgressEvent<FileReader>) => {
			if (event.target && event.target.result) {
				const data = new Uint8Array(event.target.result as ArrayBuffer);
				const workbook = XLSX.read(data, { type: 'array' });

				// Assuming the first sheet
				const sheetName = workbook.SheetNames[0];
				const worksheet = workbook.Sheets[sheetName];

				// Convert the sheet to JSON
				const jsonData = XLSX.utils.sheet_to_json<string[]>(worksheet, {
					header: 1,
				});

				// Find the first non-empty row to use as headers
				let headers: string[] = [];
				let startIndex = 0;

				for (let i = 0; i < jsonData.length; i++) {
					const row = jsonData[i];
					if (
						row.some(
							(cell) => cell !== null && cell !== undefined && cell !== ''
						)
					) {
						headers = row; // Found headers
						startIndex = i + 1; // Start processing data from the next row
						break;
					}
				}

				if (headers.length > 0) {
					// Process rows after headers
					const data = jsonData.slice(startIndex).reduce((acc, row) => {
						// Add your custom condition here to filter out specific rows
						// For example, hide rows where the first column is empty
						if (
							!row.some(
								(cell) => cell !== null && cell !== undefined && cell !== ''
							)
						) {
							return acc; // Skip empty rows
						}

						const rowData = headers.reduce(
							(
								obj: { [key: string]: string },
								header: string,
								index: number
							) => {
								obj[header] = row[index] || '';
								return obj;
							},
							{}
						);
						acc.push(rowData);
						return acc;
					}, [] as { [key: string]: string }[]);

					setHeaders(headers);
					console.log('row data', data);
					setData(data);
				} else {
					toastText('Excel file is empty or invalid!', 'error');
				}
			}
		};

		reader.readAsArrayBuffer(file);
	};

	const handleUploadFileForm = (values: any) => {
		setFile(values.file);
		handleContinue(values);
	};

	const getDataMapping = () => {
		setFileClassValues(
			buildFileValues(
				selectHeadersValues.class,
				historyOfMapping.classMapping,
				'qboClassName'
			)
		);
		setFileEmployeeValues(
			buildFileValues(
				selectHeadersValues.employee,
				historyOfMapping.employeeMapping,
				'qboEmployeeName'
			)
		);
		setFileCustomerValues(
			buildFileValues(
				selectHeadersValues.customer,
				historyOfMapping.customerMapping,
				'qboCustomerName'
			)
		);
	};

	const handleNext = () => {
		if (current == 1) {
			getDataMapping();
		}
		setCurrent(current + 1);
	};

	const closeMappingModal = () => {
		setData([]);
		setCurrent(0);
		setHeaders([]);
		setFile(null);
		setIsTimeLogUploadModalOpen(false);
		setHeadersSelectValues({
			activityDate: [],
			employee: [],
			OtherExpensesAccounts: [],
			salaryExpenseAccounts: [],
			payrollTaxesAndFringeBenefits: [],
			customer: [],
			class: [],
			hours: [],
		});
		setLoadedEcTemplateId(null);
		setEcUsingLastMapping(false);
		setEcSaveAsOpen(false);
	};

	useEffect(() => {
		setLastSyncTime(employeeLastSyncDate);
	}, [employeeLastSyncDate]);

	return (
		<div className="employee-costs-tabs">
			{/* WS-13 (ENG-332): QBO Time mismatch banner + resolution panel. */}
			{unmatchedNames.length > 0 && (
				<QboTimeMismatchBanner
					unmatchedNames={unmatchedNames}
					dismissed={bannerDismissed}
					onReviewNow={() => setMismatchPanelOpen(true)}
					onDismiss={() => setBannerDismissed(true)}
					onRestore={() => setBannerDismissed(false)}
				/>
			)}

			<QboTimeMismatchPanel
				open={mismatchPanelOpen}
				companyId={companyId}
				payPeriodId={payPeriodId}
				unmatchedNames={unmatchedNames}
				onClose={() => setMismatchPanelOpen(false)}
				onSaved={async () => {
					setMismatchPanelOpen(false);
					try {
						const res = await getApi('/employees/unmatched-names', {
							companyId,
						});
						setUnmatchedNames(res.data?.data?.unmatchedNames ?? []);
					} catch {
						// Leave the prior banner state on a refresh failure.
					}
				}}
			/>

			<div className={styles['employee-costs-tab']}>
				<Tabs
					defaultActiveKey="2"
					items={items}
					activeKey={isEmployeeCost}
					key={isEmployeeCost}
					tabBarStyle={{
						paddingLeft: '20px',
						fontSize: '18px',
					}}
					onChange={(e) => {
						setIsEmployeeCost(e);
						// onChangeKey && onChangeKey(e);
					}}
				//indicatorSize={(origin) => origin - 16}
				/>
			</div>

			{isTimeLogUploadModalOpen ? (
				<>
					<Modal
						open={isTimeLogUploadModalOpen}
						maskClosable={false}
						centered
						onCancel={() => {
							setIsTimeLogUploadModalOpen(false);
							setFile(null);
						}}
						width="70%"
						closable={false}
						footer={null}
						className="CustomMultipleFormModal"
					>
						<Row className={styles['time-sheet-modal__header']}>
							<Typography.Title
								level={2}
								className="text-center"
								style={{ fontSize: '16px' }}
							>
								Upload Employee Cost
							</Typography.Title>
							<div
								className={styles['time-sheet-modal__header-delete']}
								onClick={closeMappingModal}
							>
								<CloseSvg />
							</div>
						</Row>
						<>
							<Steps
								current={current}
								className="steps"
							>
								<Steps.Step
									title="Upload File"
									key={0}
									style={{ fontSize: '12px' }}
								/>
								<Steps.Step
									title="Header Mapping"
									key={1}
								/>
								<Steps.Step
									title="Data Mapping"
									key={2}
								/>
								<Steps.Step
									title="Data Preview"
									key={3}
								/>
							</Steps>
							{(current === 1 || current === 2) && (
								<div className={styles['ec-mapping-template-bar']}>
									<span className={styles['ec-mapping-template-bar__label']}>
										Mapping Template
									</span>
									<Select
										className={styles['ec-mapping-template-bar__select']}
										placeholder="Load Mapping Template…"
										allowClear
										size="middle"
										value={
											loadedEcTemplateId ??
											(ecUsingLastMapping ? EC_LAST_USED_VALUE : undefined)
										}
										onChange={(value) => {
											if (value === EC_LAST_USED_VALUE) return;
											handleApplyEcTemplate(value);
										}}
										onClear={() => {
											setLoadedEcTemplateId(null);
											setEcUsingLastMapping(false);
										}}
										options={[
											...(ecUsingLastMapping
												? [
														{
															value: EC_LAST_USED_VALUE,
															label: 'Last Used Mapping (unsaved)',
														},
												  ]
												: []),
											...ecMappingTemplates.map((t) => ({
												value: t.id,
												label: t.name,
											})),
										]}
										optionRender={(option) => {
											const template = ecMappingTemplates.find(
												(t) => t.id === option.value
											);
											return (
												<div
													style={{
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'space-between',
														gap: 8,
													}}
												>
													<span
														style={{
															overflow: 'hidden',
															textOverflow: 'ellipsis',
															whiteSpace: 'nowrap',
														}}
													>
														{option.label}
													</span>
													{template && (
														<DeleteOutlined
															style={{ color: '#ff4d4f', fontSize: 12 }}
															onClick={(e) => {
																e.stopPropagation();
																confirmDeleteEcTemplate(template);
															}}
														/>
													)}
												</div>
											);
										}}
										notFoundContent="No saved templates"
									/>
									{current === 2 && (
										<Button
											className={styles['ec-mapping-template-bar__save-btn']}
											onClick={() => void handleSaveEcTemplate()}
										>
											Save Template
										</Button>
									)}
								</div>
							)}
							{current === 0 ? (
								<UploadFileForm
									handleUploadFileForm={handleUploadFileForm}
									handleNext={handleNext}
									file={file}
								/>
							) : current === 1 ? (
								<HeaderMappingForm
									handleHeaderMappingForm={handleNext}
									handleBack={handleBack}
									headers={headers}
									isTimeActivityChecked={isTimeActivityChecked}
									handleCheckboxChange={setIsTimeActivityChecked}
									selectHeadersValues={selectHeadersValues}
									selectHeadersValidation={selectHeadersValidation}
									handleSelectChange={handleSelectChange}
									handleHeadersSubmitButton={handleHeadersSubmitButton}
								/>
							) : current === 2 ? (
								<DataMappingForm
									handleHeaderMappingForm={handleNext}
									handleBack={handleBack}
									isTimeActivityChecked={isTimeActivityChecked}
									headers={headers} // Add missing prop
									fileClassValues={fileClassValues}
									fileEmployeeValues={fileEmployeeValues}
									fileCustomerValues={fileCustomerValues}
									handleTreeSelectChange={handleTreeSelectChange}
									handleEmployeeSelectChange={handleEmployeeSelectChange}
									handleCustomerTreeSelectChange={
										handleCustomerTreeSelectChange
									}
									classList={classList}
									employees={employees}
									customerOptions={customerOptions}
								/>
							) : current === 3 ? (
								<DataReviewTable
									data={data}
									selectHeadersValues={selectHeadersValues}
									handleBack={handleBack}
									isTimeActivityChecked={isTimeActivityChecked}
									handleImportedActivity={handleImportedEmployeeCost}
									fileClassValues={fileClassValues}
									fileEmployeeValues={fileEmployeeValues}
									fileCustomerValues={fileCustomerValues}
									classList={classList}
									employees={employees}
									payPeriodsData={payPeriodId}
									customerOptions={customerOptions}
									closeMappingModal={closeMappingModal}
									checkedHeaders={checkedTitles}
									handleShowEmployeeCostRefresh={(data: any) =>
										setShowEmployeeCostRefresh(data)
									}
								/>
							) : (
								<div>
									<h1>Error</h1>
								</div>
							)}
						</>
						<Modal
							open={ecSaveAsOpen}
							title="Save mapping template"
							okText="Save"
							okButtonProps={{ disabled: ecSaveAsName.trim() === '' }}
							onOk={() => void handleSaveAsEcTemplate()}
							onCancel={() => setEcSaveAsOpen(false)}
							destroyOnHidden
						>
							<Input
								autoFocus
								maxLength={100}
								placeholder="Template name"
								value={ecSaveAsName}
								onChange={(e) => setEcSaveAsName(e.target.value)}
								onPressEnter={() => void handleSaveAsEcTemplate()}
							/>
						</Modal>
					</Modal>
				</>
			) : null}

			<SmartImportWizard
				open={smartImportOpen}
				payPeriodId={payPeriodId}
				payPeriodLabel={payPeriodLabel}
				initialFile={chatImportFile}
				onClose={() => {
					setSmartImportOpen(false);
					setChatImportFile(null);
				}}
				onImported={(importedNewFieldLabels?: string[]) => {
					// Refresh row data AND the column/config metadata so newly
					// created fields (new columns) appear, not just new rows/values.
					dispatch(
						getEmployeeCostAction({
							page: 1,
							limit: -1,
							sort: 'asc',
							payPeriodId,
							includeInactive,
						})
					);
					if (payPeriodId) {
						dispatch(getEmployeeCostColumnAction({ payPeriodId }));
						dispatch(getConfiguration({ payPeriodId }));
					}
					// Close the wizard FIRST, then (if the import created new fields)
					// raise the GL-mapping reminder so it never stacks on the wizard.
					setSmartImportOpen(false);
					setChatImportFile(null);
					if (importedNewFieldLabels && importedNewFieldLabels.length > 0) {
						setNewFieldLabels(importedNewFieldLabels);
						setShowNewFieldsModal(true);
					}
				}}
			/>

			<NewFieldsModal
				open={showNewFieldsModal}
				fieldLabels={newFieldLabels}
				onGoToConfigurations={goToConfigurations}
				onLater={() => setShowNewFieldsModal(false)}
			/>
		</div>
	);
};

export default EmployeeCosts;
